import { CurrentOrderState } from '../currentOrder';
import { TransferNormalized } from '@wetransfer/transfer/spaces-bundle/store/types';
import { initialState } from '@wetransfer/transfer/store';
import type { CustomWallpapersState } from '@wetransfer/transfer/store/customWallpapers';
import type { PaymentIntegrationsState } from '@wetransfer/transfer/store/paymentIntegrations';

import {
  BillingPreview,
  Subscription,
  UnpaidInvoice,
  Checkout,
} from './billing';

export * from './billing';

export interface Contact {
  id: string;
  name?: string;
  company?: string;
}

export interface NotificationStore {
  panel: Notification;
}

export type InitialState = typeof initialState;

export type PendingState = Record<string, boolean>;

export type UserState = State['user'];

export type AuthState = State['auth'];

export type State = InitialState & {
  contacts?: {
    isLoaded: boolean;
    list: Record<string, Contact>;
  };
  account: InitialState['account'] & {
    subscription: Subscription;
    unpaidInvoices?: UnpaidInvoice[];
    paidUpgradePreview?: BillingPreview;
    wallpaper_link?: string;
    title?: string;
    checkout?: Checkout;
    payment?: {
      error?: string;
    };
  };
  // The route object in the Redux store gets transformed into
  // a Route object with more properties.
  route: {
    shouldRedirect: (
      user: InitialState['user'],
      search?: string,
      account?: InitialState['account']
    ) => boolean;
    redirectTo: (
      path: string,
      user: InitialState['user'],
      account?: InitialState['account']
    ) => void;
  };
  pending: PendingState;
  transfers?: {
    isLoaded: boolean;
    list: TransferNormalized[];
  };
  notification: NotificationStore;
  customWallpapers: CustomWallpapersState;
  paymentIntegrations: PaymentIntegrationsState;
  currentOrder: CurrentOrderState;
};

export interface TransferNotification {
  text: string;
  date: string;
}

enum NotificationCategory {
  ERROR = 'error',
  DEFAULT = 'default',
}

export interface Notification {
  category: NotificationCategory;
  html: string;
  duration: number;
  value: string;
}

export interface WallpaperRaw {
  id: number;
  source_url: string;
  title: string;
  href: string;
  src: string;
  resized_src_small: string;
  resized_src_medium: string;
  resized_src_large: string;
  wallpaper_type: string;
}

export interface ChannelWallpaper {
  id: number;
  sourceUrl: string;
  wallpaperType: 'image' | 'video';
  title: string | null;
  href: string | null;
  src: string;
  resizedSrcLarge?: string;
  resizedSrcMedium?: string;
  resizedSrcSmall?: string;
}
